import React, { useState, useEffect, useContext } from 'react'
import Layout from 'components/layout'
import SEO from 'components/seo'
import Slider from 'components/slider'
import { injectIntl, Link } from 'gatsby-plugin-intl'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import { colors, breakpoints } from 'utils/utils'
import Img from 'gatsby-image'
import YouTube from 'react-youtube'
import YoutubeVideo from 'components/YoutubeVideo'
import HomePopup from 'components/homePopup'
import BackgroundImage from 'gatsby-background-image'
import { GlobalStateContext } from '../context/globalContext'
import { GlobalDispatchContext } from '../context/globalContext'

export default injectIntl( props => {

  const locale = props.intl.locale

  const state = useContext(GlobalStateContext)
  const dispatch = useContext(GlobalDispatchContext)  
    
  const { section1, section2, section3, section4, section5, section6 } = props.data;

  const seo = section1.seo;

  const [ isVideoReady, setIsVideoReady ] = useState(false)
  const [ youtubeCookies, setYoutubeCookies ] = useState(false)

  useEffect(() => {
    if(state.cookieSettings) {
      const parsedCookies = JSON.parse(state.cookieSettings)
      if(parsedCookies["analytics"]) {
        setYoutubeCookies(true)
      }
    }
  }, [state])

  useEffect(() => {
      if(state.otherLanguageSlug !== props.pageContext.otherLanguageSlug) {
          dispatch(state.changeOtherLanguageSlug(props.pageContext.otherLanguageSlug))
      }
  }, [state, dispatch, props.pageContext.otherLanguageSlug])

  const opts = {
    playerVars: {
        controls: 0,
        showInfo: 0,
        rel: 0,
        autoplay: 1,
        mite: 1,
        playsinline: 1
    },
    host: "https://www.youtube-nocookie.com"
  }

  const videoHeroId = section1.youtubeVideo.youtubeId

  const videoOnReady = (event) => {
    const player = event.target
    player.playVideo()
    player.mute()
  }

  const videoOnChange = (event) => {
    const player = event.target
    if(event.data === 1) {
        setIsVideoReady(true)
    }
    player.playVideo()
  }

  const youtubeImage = section1.youtubeVideo.youtubeImage.file.url


  return (
      <Layout>
        <SEO 
            title={seo.title}
            keywords={seo.attributes[0].keywords}
            slug={seo.slug === '/' ? '' : seo.slug}
            description={seo.attributes[0].description}
            lang={props.pageContext.language}
        />
        {
          <Main background={youtubeImage}>
            <HomePopup />
            <section className="section section--first">
                <div className={isVideoReady ? 'hero_video show' : 'hero_video'} >
                    <BackgroundImage fluid={section1.youtubeVideo.youtubeImage.fluid} />
                    {
                      youtubeCookies &&
                      <YouTube videoId={videoHeroId} opts={opts} onReady={videoOnReady} onStateChange={videoOnChange} />
                    }
                </div>
                <div className="section__wrapper">
                    <div className="content">
                        <h1>{section1.title}</h1>
                    </div>
                    <div className="cta">
                        <Link key={section1.cta[0].id} to={`/${locale}/${section1.cta[0].href}`}>
                        <div>
                            <h2>{section1.cta[0].value}</h2>
                            <span>{section1.data.content1}</span>                
                        </div>
                        </Link>
                        <Link key={section1.cta[1].id} to={`/${locale}/${section1.cta[1].href}`}>
                        <div>
                            <h2>{section1.cta[1].value}</h2>
                            <span>{section1.data.content2}</span>                
                        </div>
                        </Link>   
                    </div>     
                </div>  
            </section>            
            <section className="section section--second">
              <div className="content">
                <div>
                    <h2>{section2.title}</h2>
                    <p>{section2.data.content}</p>
                    <Link key={section2.cta[0].id} to={`/${locale}/${section2.cta[0].href}`}>{section2.cta[0].value}</Link>
                </div>
              </div>
              <div className="video">
                <YoutubeVideo videoId={section2.youtubeVideo.youtubeId} opts={{host: "https://www.youtube-nocookie.com"}}/>
              </div>
            </section>

            <section className="section section--third">
              <div className="content">
                <h2>{section3.title}</h2>
              </div>                
              <div className="brands"> 
                <Slider content={section3} slidesMobile="1" slidesDesktop="5"/>
              </div>                
            </section>
             
            <section className="section section--fourth">                
                <div className="content">
                  <h2>{section4.title}</h2>
                  <p>{section4.data.content}</p>
                  <Link key={section4.cta[0].id} to={`/${locale}/${section4.cta[0].href}`}>{section4.cta[0].value}</Link>
                </div>                
                <div className="image">
                    <Img fluid={section4.media[0].fluid} alt={section4.media[0].title}/>
                </div>                
            </section>                
            <section className="section section--fifth">
              <div className="content">
                <div>
                  <p>{section5.data.content1}</p>
                  <Link key={section5.cta[0].id} to={`/${locale}/${section5.cta[0].href}`}>{section5.cta[0].value}</Link>
                </div>
              </div>
              <div className="image">
                <Img style={{minHeight:"100%"}} fluid={section5.media[0].fluid} alt={section5.media[0].title}/>                
                <h2>{section5.title}</h2>
              </div>
            </section>

            <section className="section section--sixth">
               <h2>{section6.title}</h2>
               <Slider content={section6} slidesMobile="1" slidesDesktop="1"/> 
            </section>              
          </Main>
        }
      </Layout>
  )
})

const Main = styled.main`
  .gatsby-image-wrapper {
    /* filter: blur(1px); */
  } 

  .section {
    padding: 0 3.6rem;
    &:not(.section--first) {
        min-height: 25rem;
        max-height: 30rem;
        ${breakpoints.md}{
            min-height: unset;
            max-height: unset;
        }
    }
    &--first {
        position: relative;
        padding: 0;
        overflow: hidden;
        .hero_video {
            > div {
                background-image: ${props => `url(${props.background})`};
                background-repeat: no-repeat;
                background-size: cover;
                box-sizing: border-box;
                position: absolute!important;
                top: 50%;
                left: 50%;
                width: 177.77777778vh;
                min-width: 100%;
                height: 56.25vw;
                min-height: 100%;
                transform: translate(-50%, -50%);
                display: flex;
                flex-direction: column;
                z-index: -1;
            }
            &.show {
                iframe {
                    opacity: 1;
                    @media (hover: none) and (pointer: coarse) {
                        transform: scale(1.3);
                    }
                }
            }
        }
        iframe {
            display: block;
            width: 100%;
            height: 100%;            
            /*filter: contrast(0.4) blur(2px); //this is for video AGN7FxcXKMs*/
            opacity: 0;
            flex-grow: 1;
			      transition: opacity .3s ease-in-out;
        }
    }

    &__wrapper {                
      padding: 0;
      height: 100%;
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      .content {
        margin: 6rem 0 0 4rem;
        max-width: 65vw;
        ${breakpoints.xl} {
            max-width: 60vw;
        }

        ${breakpoints.sm} {
          max-width:100%;
          text-align: center;
          margin: 10rem 0 ;
          display: flex;
          justify-content: center;
          align-items: center;
          align-content: center;
        }
        h1 {
          color : #FFF;
          font-size: 5rem;
          font-weight: 700;
          letter-spacing: 0em;

          ${breakpoints.md} {
            font-size: 3.5rem;
          }
        }
      }
      .cta {
        
        @keyframes VibrateTrans {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: .9;
            transform: scale(1.01);
          }
        }

        margin: 2rem 0 4rem 4rem;
        animation: VibrateTrans 2s linear infinite;
        &:hover {
          animation: none;
        }

        ${breakpoints.sm} {
          margin: 0;
        }
        display: flex;

        a {
          text-decoration: none;

          div { 
            color: ${colors.tertiary};
            max-width: 225px;
            height: 100%;
            padding: 2rem 1.5em;
            background-color: ${colors.primary};

            h2 {
              font-size: 1.2rem;
              display: inline-block;
              margin-bottom: 1rem;
              margin-top: 0;
            }
          }
          &:nth-of-type(2) {
            div {
              background-color: ${colors.secondary};
              color: ${colors.primary};
            }
          }
          
          &:hover {
            z-index: 1;
            transform: scale(1.05);
            animation: none;
            div {
              border-radius: 10px;
            }
          }
        }
      }
    }

    &--second {
      display: flex;
      height: min-content;
      padding: 0;

      ${breakpoints.md}{
        flex-direction: column-reverse;
      }
      .content {
          width: 50%;
          ${breakpoints.md}{
              width: 100%;
              padding: 3rem 2rem;
              min-height: 25rem;
          }
          > div {
              max-width: 22rem;
              margin: 0 auto;
              ${breakpoints.md} {
                max-width: unset;
              }
          }
          background-color: ${colors.primary};
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-content: center;
          color: ${colors.tertiary};
          h2 {
            margin: 1rem 0;
            text-transform: uppercase;
            font-size: 2.4rem;
            font-weight: bold;
            line-height: 2.8rem;
            ${breakpoints.sm}{
              padding: 0;
              margin-bottom: 1rem;
            }
            ${breakpoints.md} {
              text-align: center;
            }
          }
          p {
            line-height: 1.7rem;
            ${breakpoints.sm}{
              padding: 0;
              margin-bottom: 1rem;
            }
            ${breakpoints.md} {
              text-align: center;
            }
          }
          a {
            display: block;
            margin: 1rem 0;
            text-decoration: none;
            color: ${colors.tertiary};
            background: ${colors.quaternary};
            padding: 1rem;
            width: fit-content;
            ${breakpoints.sm}{
              margin: 0;
            }
            ${breakpoints.md} {
              margin: 1rem auto;
            }
          }
      }
      .video {
          width: 50%;
          display: flex;
          background: ${colors.quaternary};
          ${breakpoints.md}{
              width: 100%;
              min-height: 25rem;   
          }
          video, iframe, & > div {
            width: 100%;
            height: 100%;
            min-height: 25rem;
          }
      }
    }

    &--third {
        display: flex;
        flex-direction: column;
        justify-content: center;
        h2 {
            font-size: 3rem;
            font-weight: bold;
            text-align: center;
            margin-bottom: 2rem;
        }
    
        .slick-slider {
            width: 100%;
            margin: 0 auto;
            ${breakpoints.md} {
                width: 90%;
            }
        }
        .slick-slide {
            ${breakpoints.md} {
                min-height: 11rem;
            }
            > div {
                max-width: 90%;
                text-align: center;
                width: 100%;
                ${breakpoints.md} {
                    margin: auto;                  
                    max-width: 70%;
                }
                img {
                    width: 100%;
                    height: auto;
                    max-height: 11rem;
                }
            } 
        }
    }

    &--fourth {
      padding: 0;
      display: flex;
      max-width: 75%;
      margin: auto auto 3rem;
      overflow: hidden;
      ${breakpoints.md} {
        padding: 0;
        flex-direction: column;
      }
      .content {
        padding: 1rem;
        width: 50%;
        display:flex;
        flex-direction: column;
        justify-content: space-evenly;

        ${breakpoints.md} {
          width: 100%;
          height: 300px;
          align-items: center;
          text-align: center;
        }

        h2 {
            margin: 1rem 0 0;
            font-size: 3rem;
            font-weight: bold;
            width: 80%;
            ${breakpoints.md} {
              font-size: 2rem;
            }
            ${breakpoints.md} {
                width: 100%;                
            }
        }
        p {
            width: 80%;
            ${breakpoints.md} {
                width: 100%;
            }
        }

        a {
          background-color: ${colors.quaternary};
          color: ${colors.tertiary};
          width: fit-content;
          padding: 1rem;
          text-decoration: none;
        }
      }
      .image {
        width: 50%;
        margin: auto;
        ${breakpoints.md} {
          width: 100%;
        }
        img {
            width: 100%;
            margin: 0 auto;
            display: block;
            top: 50%!important;
            left: 50%!important;
            transform: translate(-50%, -50%);
        }
      }
    }

    &--fifth {
      padding: 0;
      margin: 0;
      display:flex;
      flex-direction: row-reverse;
      max-height: 30rem;
      overflow: hidden;

      ${breakpoints.md} {
        flex-direction: column;
      }
      .content {
        display:flex;
        flex-direction: column;
        width: 50%;
        ${breakpoints.md} {
            width: 100%;
            padding: 3rem 1rem;
            min-height: 25rem;
        }
        background-color: ${colors.primary};
        color: ${colors.tertiary};
        padding: 5rem 2rem;
        div {
            margin: auto;
            max-width: 60%;
            ${breakpoints.md} {
              max-width: unset;
              margin: auto 1rem;
            }
        }
        p{
          max-width: 80%;
          margin-bottom: 2rem;
          ${breakpoints.md} {
            max-width: unset;
            text-align: center;
          }
        }
        a {
          display: block;
          margin-top: 1rem;
          background-color: ${colors.quaternary};
          color: ${colors.tertiary};
          width: fit-content;
          padding: 1rem;
          text-decoration: none;
          ${breakpoints.md} {
            margin: 1rem auto 0 auto;
          }
        }
      }
      .image {
        position: relative;
        width: 50%;
        &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
            height: 100%;
            background-color: ${colors.secondary};
            opacity: .6;
            z-index: 1;
        }
        ${breakpoints.md} {
          width: 100%;
          max-height: 25rem;
        }
        h2 {
          width: 300px;
          position: absolute;
          color: ${colors.tertiary};
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index:10;
          text-align:right;
          font-weight: bold;
          font-size: 4rem;
          margin: 0;
          ${breakpoints.md} {
              width: min-content;
          } 
        }
      }
    }
    &--sixth {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin: 2rem 0;
      h2 {
        font-size: 3rem;
        font-weight: bold;
        text-align: center;
        margin-bottom: 2rem;
      }
      > div {
        max-width: 100rem;
        margin: 0 auto;
        width: 100%;
      }

      div:nth-child(1) {
        width: 55%;
        margin: 0 auto;
        ${breakpoints.md} {
            width: 90%;
        }
      }
      .slick-slide {
        > div {
          margin: auto;
          max-width: 50%;
          text-align: center;
          ${breakpoints.md} {
              max-width: 70%;
          }
        } 
      }
    }
  }

`

export const query = graphql`
  query($language: String) {
    
    section1 : contentfulSection(name: {eq: "HP-section-1"}, node_locale: {eq: $language}) {
      title
      cta {
        id
        value
        href
      }
      seo {
        title
        slug
        attributes {
          description
          keywords
        }
      }
      data {
        content1
        content2
      }
      youtubeVideo {
        youtubeId
        youtubeImage {
          file {
            url
          }
          fluid(quality: 90, maxWidth: 1920) {
            ...GatsbyContentfulFluid_withWebp_noBase64            
          }        
        }
      }
    }

    section2 : contentfulSection(name: {eq: "HP-section-2"}, node_locale: {eq: $language}) {
      id
      title
      youtubeVideo {        
        youtubeId
      }
      data {
        content
      }
      cta {
        id
        value
        href
      }
    }

    section3: contentfulSection(name: {eq: "HP-section-3"}, node_locale: {eq: $language}) {
      title
      media {
        id
        title
        file {
          url
        }
      }
    }

    section4: contentfulSection(name: {eq: "HP-section-4"}, node_locale: {eq: $language}) {
      title
      media {
        title
        description
        fluid {
          ...GatsbyContentfulFluid_withWebp_noBase64  
        }
      }
      data {
        content
      }
      cta {
        id
        href
        value
      }
    }
    section5: contentfulSection(name: {eq: "HP-section-5"}, node_locale: {eq: $language}) {
      title
      media {
        id
        title
        fluid {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      cta {
        id
        href
        value
      }
      data {
        content1
      }
    }

    section6: contentfulSection(name: {eq: "HP-section-6"}, node_locale: {eq: $language}) {
      title
      media {
        id
        title
        fluid {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
    }
}`
